/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


import Immutable from 'immutable';


export default (entities) =>
{
  let state = new Immutable.Map();

  for (const entity of entities)
  {
    state = state.set(entity.variant, entity);
  }

  return state;

}
